/**
 * TrendEvenIcon/index.js
 * desc: line chart trending even icon
 * note: entity icon via IconButton; defaults its tooltip + accessible name to the
 *       icon label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const TrendEvenIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="trend-even icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.trendEven.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 8"><path d="M19 4l-4-4v3H0v2h15v3l4-4z"/></svg>
    </IconButton>
);


export default TrendEvenIcon;
